<template>
  <ul :class="$style.listContainer">
    <li
      v-for="(analysisItem, analysisItemIndex) in dirtyVisibleAnalysis"
      :key="analysisItem.id"
      :class="[
        $style.listItem,
        dirtySelectedTabIndex === analysisItemIndex
          ? $style.activeListItem
          : null,
      ]"
      @click="selectAnalysis(analysisItemIndex)"
    >
      <b-tooltip
        :active="analysisItem.title.length > 14"
        :label="analysisItem.title"
        position="is-right"
        size="is-medium"
        multilined
      >
        {{ getAnalysisTitle(analysisItem.title) }}
      </b-tooltip>
    </li>
  </ul>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { GripAnalysis } from '../../../store/types/grip.types';

@Component({})
export default class GripAnalysisNavigationTabs extends Vue {
  @Prop() public visibleAnalysis!: GripAnalysis[];
  @Prop() public selectedTabIndex!: number;
  public dirtyVisibleAnalysis: GripAnalysis[] = [];
  public dirtySelectedTabIndex: number = 0;

  public mounted(): void {
    this.dirtyVisibleAnalysis = JSON.parse(
      JSON.stringify(this.visibleAnalysis),
    );
    this.dirtySelectedTabIndex = this.selectedTabIndex;
  }

  public selectAnalysis(analysisItemIndex: number): void {
    this.$emit('selectAnalysis', analysisItemIndex);
  }

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public getAnalysisTitle(analysisTitle: string): string {
    if (analysisTitle.length > 14) {
      return `${analysisTitle.substring(0, 12)} ...`.toUpperCase();
    }
    return analysisTitle.toUpperCase();
  }
}
</script>

<style lang="scss" module>
.listContainer {
  display: flex;
  flex-direction: row;
  padding-top: 1rem;
  margin-bottom: -0.5rem;
}
.listItem {
  width: 150px;
  text-align: center;
  color: #9f9f9f;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
  cursor: pointer;
}
.activeListItem {
  color: #00205b;
  border-bottom: 2px solid #00205b;
}
</style>
